import { render, staticRenderFns } from "./HeaderIcon.vue?vue&type=template&id=0362e326&"
import script from "./HeaderIcon.vue?vue&type=script&lang=js&"
export * from "./HeaderIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0362e326')) {
      api.createRecord('0362e326', component.options)
    } else {
      api.reload('0362e326', component.options)
    }
    module.hot.accept("./HeaderIcon.vue?vue&type=template&id=0362e326&", function () {
      api.rerender('0362e326', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverableTemplates/HeaderIcon.vue"
export default component.exports